import { z } from "zod";

import { useFeatureFlags } from "@smart/bridge-feature-flags-dom";
import { useStorage } from "@smart/itops-hooks-dom";
import { Alert, Link } from "@smart/itops-sb-design-system-dom";

import { useReviewFormsNavigation } from "../navigate";

const bannerText = (count: number) =>
  count === 1
    ? "1 form sends its own reminder message instead of this one, and still follows the schedule below."
    : `${count} forms send their own reminder message instead of this one, and still follow the schedule below.`;

type CustomReminderMessageBannerProps = {
  count?: number;
};

export const CustomReminderMessageBanner = ({
  count,
}: CustomReminderMessageBannerProps) => {
  const { "LINK-3736": automaticRemindersFlag } = useFeatureFlags();
  const { canNavigate, openBuilder } = useReviewFormsNavigation();
  const [dismissed, setDismissed] = useStorage({
    key: "dismissed-banner.custom-reminder-message",
    storage: "session",
    schema: z.boolean(),
    defaultValue: false,
  });

  if (!automaticRemindersFlag || !count || dismissed) return null;

  return (
    <Alert
      variant="info"
      palette="default"
      content={
        <div className="flex items-center justify-between gap-[1.6rem]">
          <span>{bannerText(count)}</span>
          {canNavigate && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
              text={count === 1 ? "Review form" : "Review forms"}
              onClick={openBuilder}
              dataTestId="custom-reminder-message-review-forms"
            />
          )}
        </div>
      }
      onClose={() => setDismissed(true)}
    />
  );
};
